import { Link, useLocation } from 'react-router-dom';
import { ReactNode } from 'react';
import { LanguageBar } from '@/components/LanguageBar';
import { Logo } from '@/components/Logo';
import { useT } from '@/i18n';

// Booking-flow steps have no footer in the PDF — only the landing / policy do.
const NO_FOOTER = ['/sesiones', '/ubicacion', '/menu', '/pago'];

/**
 * `brand`: paleta de los emails de marca (fondo #1F1209, texto crema #FFFDE5).
 * Se usa en la confirmación y en las páginas de autogestión (gestionar /
 * modificar / cancelar) para que todo el post-pago sea coherente con el email.
 */
export function Layout({
  children,
  brand = false,
}: {
  children: ReactNode;
  brand?: boolean;
}) {
  const { pathname } = useLocation();
  const showFooter = !NO_FOOTER.includes(pathname);
  const t = useT();
  const lineCls = brand ? 'border-[#3a321f]' : 'border-line-subtle';
  return (
    <div
      className={`min-h-screen flex flex-col overflow-x-hidden ${
        brand ? '' : 'bg-ink text-ink-body'
      }`}
      style={brand ? { background: '#1F1209', color: '#FFFDE5' } : undefined}
    >
      <header className={`border-b ${lineCls}`}>
        <div className="max-w-6xl mx-auto px-6 py-2.5 flex flex-wrap items-center justify-between gap-3">
          <Link
            to="/"
            className="block flex-shrink-0"
            aria-label={t('layout.header.logo.aria_label')}
          >
            <Logo className={`h-9 w-auto ${brand ? 'text-[#FFFDE5]' : 'text-ink-body'}`} />
          </Link>
          <LanguageBar />
        </div>
      </header>
      <main className="flex-1">{children}</main>
      {showFooter && (
        <footer className={`border-t ${lineCls}`}>
          <div className="max-w-6xl mx-auto px-6 py-7">
            <Link
              to="/"
              className="inline-block"
              aria-label={t('layout.footer.logo.aria_label')}
            >
              <Logo className={`h-9 w-auto ${brand ? 'text-[#FFFDE5]' : 'text-ink-body'}`} />
            </Link>
          </div>
        </footer>
      )}
    </div>
  );
}
